import React, { useEffect } from 'react';
import { Grid } from '@mui/material';
import FilterBar from './filterBar';
import FilesTable from './creativesTable/creativesTable';
import { useDispatch, useSelector } from 'react-redux';
import SearchUsingFilter from './searchUsingFilter/index';
import UploadCreative from './uploadCreatives/uploadCreative';
import { getCreatives } from '../../../redux/thunks/creativeUploadThunk';

const Creatives = () => {
    const dispatch = useDispatch();
    const { company } = useSelector(state => state.company);
    useEffect(() => {
        if (company.id) {
            dispatch(getCreatives({ companyId: company.id }));
        }
    }, [company.id]);
    return (
        <>
            <FilterBar />
            <Grid container>
                <Grid item xs={12}>
                    <UploadCreative />
                </Grid>
                <Grid item xs={12}>
                    <SearchUsingFilter />
                </Grid>
                <Grid item className='mt-5' xs={12}>
                    <FilesTable />
                </Grid>
            </Grid>
        </>
    );
};

export default Creatives;
